<template>
  <div class="page">
    <div class="nav">
      <span :class="selected == 'IQC进料分析' ? 'selected' : ''" @click="toggle('IQC进料分析')">IQC进料分析</span>
      <span>|</span>
      <span :class="selected == 'IQC进料明细' ? 'selected' : ''" @click="toggle('IQC进料明细')">IQC进料明细</span>
    </div>

    <analyies v-if="selected == 'IQC进料分析'" />

    <detail v-if="selected == 'IQC进料明细'" />

  </div>
</template>

<script>
import Analyies from "@/components/OutprodIQCReport/Analyies.vue";
import Detail from "@/components/OutprodIQCReport/Detail.vue";

export default {
  components: {
    Analyies,
    Detail
  },
  data() {
    return {
      selected: 'IQC进料分析',
    }
  },
  methods: {
    toggle(val) {
      this.selected = val
    }
  }
}
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559F;
}
@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }
}
</style>